// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBgmB-Jx-ODPAN8NEC6wf0_fe5BvR2eVYw",
    authDomain: "ema-john-simple-cc053.firebaseapp.com",
    projectId: "ema-john-simple-cc053",
    storageBucket: "ema-john-simple-cc053.appspot.com",
    messagingSenderId: "508916971457",
    appId: "1:508916971457:web:8ec45e988365ce0661a140",
    measurementId: "G-X2MTF421S6"
};

export default firebaseConfig;